// MST
import { types, flow } from 'mobx-state-tree'

const state = {
  app_isLoading: types.optional(types.boolean, true),
}

export const AppStoreModel = types
  .model('App')
  .props(state)
  .actions(self => ({
    APP_SET_LOADING: (payload: boolean) => {
      self.app_isLoading = payload
    },
  }))
  .actions(self => ({
    app_setLoading: flow(function* () {
      const delay = (ms: number) => new Promise(res => setTimeout(res, ms))

      self.APP_SET_LOADING(true)

      yield delay(3000)

      self.APP_SET_LOADING(false)
    }),
  }))

export const createAppStoreDefaultModel = () => types.optional(AppStoreModel, {})
